export const DEFAULT_PAGE_SIZE = 50;
export const PAGE_SIZE_OPTIONS = ["10", "25", "50", "100"];
